module.exports = __webpack_public_path__ + "static/media/azure-devops-engineer-expert.f47d764b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/azure-devops-engineer-expert.png
// module id = 1377
// module chunks = 0